import { grabEmployees, grabRequiredManagerPendingEmployees, grabRequiredApprovalGroupEmployees, grabEmployeeSearch } from "../dataLayer/employeeList";
import { grabSupervisors } from "../dataLayer/employee";
import { TimesheetType } from "../interfaces/TimesheetInterface";
import { EmployeeInfo } from "../interfaces/EmployeeInfoInterface";

class EmployeeManager {

    // Method to retrieve employees based on pay period, type, and supervisor ID
    async getEmployees(payPeriodID: number, type: TimesheetType, supervisorID: number, userID: number | null): Promise<any> {

        try {
            // Call the grabEmployees function to fetch employee data
            const authData = await grabEmployees(payPeriodID, type, supervisorID, userID);

            // Log the successful retrieval of employee data for debugging purposes
            console.log("Grab successful:", authData);

            // Return the employee data (authentication data in this context)
            return authData;

        } catch (error) {
            // Log any errors that occur during the data retrieval process
            console.error("Error during grabbing list:", error);
            
            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

    // Method to get required manager pending employees
    async getRequiredManagerPendingEmployees(payPeriodID: number, managerEmployeeID: number, adminUserEmployeeID?: number): Promise<any> {
        try {
            const authData = await grabRequiredManagerPendingEmployees(payPeriodID, managerEmployeeID, adminUserEmployeeID);
            console.log("Required manager pending employees grab successful:", authData);
            return authData;
        } catch (error) {
            console.error("Error during grabbing required manager pending employees:", error);
            throw error;
        }
    }

    // Method to get required approval group employees
    async getRequiredApprovalGroupEmployees(payPeriodID: number, approvalGroupID: number, adminUserEmployeeID?: number): Promise<any> {
        try {
            const authData = await grabRequiredApprovalGroupEmployees(payPeriodID, approvalGroupID, adminUserEmployeeID);
            console.log("Required approval group employees grab successful:", authData);
            return authData;
        } catch (error) {
            console.error("Error during grabbing required approval group employees:", error);
            throw error;
        }
    }

    // Method to get supervisors
    async getSupervisors(): Promise<EmployeeInfo[]> {
        try {
            // Call the data layer function to fetch supervisors
            const response = await grabSupervisors();
            console.log("Supervisors fetched successfully:", response);
            
            // Return the supervisors data
            return response.data;

        } catch (error) {
            // Log and re-throw any errors that occur during the fetch process
            console.error("Error during supervisors fetch:", error);
            throw error;
        }
    }

    // Method to search for employees by ID or name
    async searchEmployees(searchString: string, payPeriodID: number, adminUserEmployeeID?: number): Promise<any> {
        try {
            // Call the data layer function to search for employees
            const response = await grabEmployeeSearch(searchString, payPeriodID, adminUserEmployeeID);
            console.log("Employee search successful:", response);
            
            // Return the search results
            return response;

        } catch (error) {
            // Log and re-throw any errors that occur during the search process
            console.error("Error during employee search:", error);
            throw error;
        }
    }

}

// Export an instance of the EmployeeManager class to be used elsewhere in the application
export default new EmployeeManager();
